exports.PasswordStrengthBarModule = require('./lib/passwordStrengthBar.module').PasswordStrengthBarModule;
exports.PasswordStrengthBarComponent = require('./lib/passwordStrengthBar.component').PasswordStrengthBarComponent;
